// modals/BulkMoveModal.js
import React, { useState, useEffect } from 'react';
import { getCustomerStages } from '../utils/customerStages';

const BulkMoveModal = ({ show, customers, onConfirm, onCancel, businessType = 'insurance' }) => {
    const CUSTOMER_STAGES = getCustomerStages(businessType);
    const [targetStage, setTargetStage] = useState('');

    // 모달이 열릴 때마다 선택 초기화
    useEffect(() => {
        if (show) {
            setTargetStage('');
        }
    }, [show]);

    if (!show) return null;

    const count = customers ? customers.length : 0;

    const handleConfirm = () => {
        if (targetStage) {
            onConfirm(targetStage);
        }
    };

    const handleCancel = () => {
        setTargetStage('');
        onCancel();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1003]">
            <div className="bg-white rounded-xl max-w-md w-full p-6">
                <div className="text-center mb-6">
                    <div className="text-4xl mb-3">🔄</div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">일괄 단계 이동</h3>
                    <p className="text-gray-600 mb-3">
                        선택한 <strong>{count}명</strong>의 고객을<br />
                        어느 단계로 이동하시겠습니까?
                    </p>
                </div>

                <div className="mb-6">
                    <select
                        value={targetStage}
                        onChange={(e) => setTargetStage(e.target.value)}
                        className="w-full p-4 border-2 border-gray-300 rounded-xl text-lg focus:border-blue-500 focus:outline-none"
                    >
                        <option value="">단계를 선택하세요</option>
                        {CUSTOMER_STAGES.map(stage => (
                            <option key={stage.id} value={stage.id}>
                                {stage.emoji} {stage.title}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <button
                        onClick={handleCancel}
                        className="py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-bold text-lg hover:bg-gray-300"
                    >
                        취소
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!targetStage}
                        className="py-3 px-4 bg-purple-500 text-white rounded-xl font-bold text-lg hover:bg-purple-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        이동
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BulkMoveModal;
